import { useEffect, useState } from 'react'

import { CheckIcon, CopyIcon } from '@radix-ui/react-icons'

import useClipboard from 'hooks/use-clipboard'
import { buildURL } from 'lib/utils/links'

import Box from 'components/atomic/atoms/box'
import Button, { ButtonProps } from 'components/atomic/atoms/button'
import { IconStyled } from 'components/atomic/atoms/icon'
import { LinkedinIcon } from 'components/atomic/atoms/icons/logos/linkedin'
import { TwitterIcon } from 'components/atomic/atoms/icons/logos/twitter'

const ShareButton = (props: ButtonProps) => (
  <Button
    variant="secondary"
    css={{
      p: '$3',
      borderRadius: '$round',
      borderColor: '$text4',
      opacity: 0.7,
      '&:hover': {
        opacity: 1,
      },
    }}
    {...props}
  />
)

const ShareButtons = ({ title }: { title?: string }) => {
  const { onCopy, hasCopied } = useClipboard()

  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  return (
    <Box
      flex
      justify="center"
      css={{
        gap: '$8',
        mt: '$12',
      }}
    >
      <a
        href={buildURL('https://twitter.com/intent/tweet', {
          url: currentUrl,
          title,
        })}
        target="_blank"
        rel="noreferrer"
      >
        <ShareButton>
          <IconStyled as={TwitterIcon} size={{ '@md': 'lg' }} color="text3" />
        </ShareButton>
      </a>
      <a
        href={buildURL('https://www.linkedin.com/shareArticle', {
          mini: true,
          url: currentUrl,
          title,
        })}
        target="_blank"
        rel="noreferrer"
      >
        <ShareButton>
          <IconStyled as={LinkedinIcon} size={{ '@md': 'lg' }} color="text3" />
        </ShareButton>
      </a>
      <ShareButton onClick={() => onCopy(currentUrl)}>
        <IconStyled
          as={hasCopied ? CheckIcon : CopyIcon}
          size={{ '@md': 'lg' }}
          color="text3"
        />
      </ShareButton>
    </Box>
  )
}

export default ShareButtons
